
document.addEventListener('DOMContentLoaded', function() {
    applyProductTypeCustomizationsByParam();
});



// ******************* get type 
function applyProductTypeCustomizationsByParam() {
    const queryString = window.location.search;
    
    let typeParam = '';
    
    if (queryString.includes('type=product')) {
        typeParam = 'product';
    } else if (queryString.includes('type=cosmetics')) {
        typeParam = 'cosmetics';
    } else if (queryString.includes('type=hair-care')) {
        typeParam = 'hair-care';
    }

    if (!typeParam) {
        return;
    }

    
    const typeToClassMap = {
        'product': 'product-type-heading',
        'cosmetics': 'product-type-cosmetics',
        'hair-care': 'product-type-hair-care'
    };
    const varClassName = typeToClassMap[typeParam];

    const path = window.location.pathname.toLowerCase();
    const pathSegments = path.split('/').filter(segment => segment.length > 0);
    const rawProductType = pathSegments[pathSegments.length - 1]; 
    
    let formattedHeading = rawProductType.split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
        
    if (!formattedHeading || formattedHeading === 'All') {
        formattedHeading = typeParam.split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    const h1Element = document.querySelector('h1'); 
    
    if (h1Element) {
        h1Element.textContent = formattedHeading;
        h1Element.classList.add(varClassName); 
        h1Element.style.display = 'block';
    }
}
